import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-user-message',
  templateUrl: './modal-user-message.component.html',
  styleUrls: ['./modal-user-message.component.scss'],
  standalone: true,
  imports: [],
})
export class ModalUserMessageComponent {
  @Input() message = 'Sei sicuro di voler procedere?';
  @Input() title = 'Attenzione';
  @Input() nextBtn = 'Elimina';
  @Input() cancelBtn = 'Annulla';
  @Input() classConfirmBtn = 'btn-cancel';
  @Input() classCancelBtn = 'btn-outline';

  public activeModal = inject(NgbActiveModal);
}
